// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"alertTypeLabel_wrapper_1vlGAfp","alert":"alertTypeLabel_alert_1D9zlH_"};